import mutations from "./mutation_types.js";
import Vue from "vue";

export default {
    [mutations.SET_CURRENCIES](state, currencies) {
        state.currencies = currencies
    },
    [mutations.SET_TARIFFS](state, tariffs) {
        state.tariffs = tariffs
    },
    [mutations.SET_TARIFF_DETAILS](state, tariff_details) {
        state.tariff_details = tariff_details
    },
    [mutations.ADD_TARIFF_TYPE](state, tariff_type) {
        const sortedBy = {
          'free' : 0,
          'pre_paid' : 1,
          'surcharge' : 2,
          'subscription' : 3,
        }
        state.tariffs.push({...tariff_type})
        let tariffs = state.tariffs;
        let sorted = tariffs.sort(
          (a,b) => sortedBy[a.type] - sortedBy[b.type]
        );
    },
    [mutations.DELETE_TARIFF](state, index) {
      state.tariffs.splice(index, 1);
    },
    [mutations.SET_TARIFFS_NAMES](state) {
        let tariffs = state.tariffs;
        let types = ['free', 'pre_paid', 'surcharge', 'subscription'];
        for (var i = 0; i < types.length; i++) {
            let filtered = state.tariffs.filter((item) => {
                return item.type == types[i];
            });
            for (var j = 0; j < filtered.length; j++) {
                  let number = j < 9 ? '0'.concat(parseInt(j) + 1)  : parseInt(j) + 1;
                  let prefix = '';
                  switch (filtered[j].type) {
                    case  'free':
                      prefix = 'F';
                      filtered[j].name = 'F';
                      continue;
                      break;
                    case  'pre_paid':
                      prefix = 'P';
                      break;
                    case  'surcharge':
                      prefix = 'X';
                      break;
                    case  'subscription':
                      prefix = 'A';
                      break;
                    default:
                  }
                  filtered[j].name = prefix.concat(number);
            }
        }
    }

}